import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';

import icon1 from '../assets/images/choose-icon1.png';
import icon2 from '../assets/images/choose-icon2.png';
import icon3 from '../assets/images/choose-icon3.png';
import icon4 from '../assets/images/choose-icon4.png';
import icon5 from '../assets/images/choose-icon5.png';

const WhyChooseUs = () => {
    const { t } = useTranslation();
    const sellingPoints = [
        { icon: icon1, title: t('whyus_point1_title'), desc: t('whyus_point1_desc') },
        { icon: icon2, title: t('whyus_point2_title'), desc: t('whyus_point2_desc') },
        { icon: icon3, title: t('whyus_point3_title'), desc: t('whyus_point3_desc') },
        { icon: icon4, title: t('whyus_point4_title'), desc: t('whyus_point4_desc') },
        { icon: icon5, title: t('whyus_point5_title'), desc: t('whyus_point5_desc') },
    ];

    return (
        <section className="float-left w-100 position-relative why-choose-us-con padding-top padding-bottom main-box">
            <Container className="wow animate__animated animate__fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
                <div className="heading-title-con text-center">
                    <span className="special-text color-blue d-block wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.2s">{t('whyus_title')}</span>
                    <h2 className="wow animate__animated animate__fadeInRight" data-wow-duration="2s" data-wow-delay="0.4s" dangerouslySetInnerHTML={{ __html: t('whyus_subtitle') }}></h2>
                </div>
                <div className="choose-outer-con wow animate__animated animate__fadeInDown" data-wow-duration="2s" data-wow-delay="0.5s">
                    {sellingPoints.map((point, index) => (
                        <div className="choose-box" key={index}>
                            <figure><img src={point.icon} alt={point.title} className="img-fluid" /></figure>
                            <h6>{point.title}</h6>
                            <p className="mb-0">{point.desc}</p>
                        </div>
                    ))}
                </div>
                <div className="float-left w-100 m-auto text-center wow animate__animated animate__fadeInUp" data-wow-duration="2s" data-wow-delay="0.4s">
                    <a href="/about" className="text-decoration-none primary_btn d-inline-block">
                        {t('banner_get_started')}
                    </a>
                </div>
            </Container>
        </section>
    );
};

export default WhyChooseUs;